import { FC, memo } from 'react';
import useFieldRenderer from '../hooks/useFieldRenderer.tsx';
import { TStep } from '../types/types.ts';

/**
 * @description A component used for dynamically rendering the fields inside a step.
 * @param step
 * @param totalSteps
 */
const StepComponent: FC<{
  step: TStep;
}> = ({ step }) => {
 
  const groupedFields = useFieldRenderer(step.fields, step);

  const stepContainerId = `step-container-${step.name}`;

  return (
    <div
      key={step.name}
      id={stepContainerId}
      className="flex flex-col w-full gap-xs animate-fadeIn"
      data-testid="step-component">
      {groupedFields}
    </div>
  );
};

const Memoized = memo(StepComponent);
Memoized.displayName = 'StepComponent';

export default Memoized;
